import {PrivateCommand} from "../PrivateCommand";
import cmp from "../../../context/context";
import {log} from "../../../util/log";

export class GetCustomProvidersPrivateCommand extends PrivateCommand {
    /* STATIC */

    /* INSTANCE */
    public execute(option?: string, callback?: Function): void {
        const vendors: number[] = option?.trim().split(',').filter(id => id).map(id => parseInt(id.trim()))??cmp().customConsent?.vendorsIds()??[];
        log.debug(`Getting custom vendors: ${vendors}`);
        const result: NodeJS.Dict<boolean|undefined> = {};
        for (const vendor of vendors) {
            result[vendor] = cmp().customConsent?.vendors()[vendor];
        }
        log.debug(`Custom vendors: ${JSON.stringify(result)}`);
        if (callback) callback(result);
    }
}
